<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Chapter1#C1">1. Plantation Life and Slavery</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. The Great Fire</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. Confederate Charleston</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. Reconstruction</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. The Great Quake</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. Modern Charleston</span></p>
<p class="toc1"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?0200acf1